module.exports = __webpack_public_path__ + "img/call.29a67303.jpg";